import { NgModule } from '@angular/core';
import { LIB_CommonModule } from 'pbc.angular';
import { ZeitFilterComponent } from '.';
import { ZeitServiceModule } from '..';

@NgModule({
  imports: [
    LIB_CommonModule,
    ZeitServiceModule
  ],
  declarations: [ZeitFilterComponent],
  exports: [ZeitFilterComponent],

})
export class ZeitFilterComponentModule { }
